<template>
  <main class="root home">
    <full-page class="fullpage" ref="fullpage" :options="fpOptions">
      <AboutSlide
        data-anchor="about"
        class="section"
        @animationCallbackReady="(callback) => slideAnimations.push(callback)"
        :appLoaded="appLoaded"
      />
      <ObsessionSlide
        data-anchor="obsession"
        class="section"
        @animationCallbackReady="(callback) => slideAnimations.push(callback)"/>
      <WorkSlide
        data-anchor="work"
        class="section"
        @scrollChange="onScrollChange"
      />
      <ContactSlide
        data-anchor="contact"
        class="section"
        @animationCallbackReady="(callback) => slideAnimations.push(callback)"/>
    </full-page>
  </main>
</template>

<script>
import AboutSlide from '@/components/AboutSlide.vue'
import ObsessionSlide from '@/components/ObsessionSlide.vue'
import WorkSlide from '@/components/WorkSlide.vue'
import ContactSlide from '@/components/ContactSlide.vue'

export default {
  name: 'home',
  components: {
    AboutSlide,
    ObsessionSlide,
    WorkSlide,
    ContactSlide
  },
  props: {
    appAnimations: Array,
    appLoaded: Boolean
  },
  methods: {
    onScrollChange: function (scrollChange) {
      if (this.$refs.fullpage.api.getActiveSection().anchor === 'work') {
        this.canScroll = scrollChange
      }
    },
    onLeave: function (origin, destination, direction) {
      const shouldControlScroll = (
        origin.anchor === 'work' &&
        window.location.hash === '#work' &&
        !this.canScroll.isMobileScroll
      )
      const scrolledToDestination = (
        this.canScroll.scrolledAtEnd &&
        this.canScroll.direction === direction
      )

      if (shouldControlScroll && !scrolledToDestination) {
        return false
      }

      this.slideAnimations.forEach((callback) => callback(origin, destination, direction))
      this.appAnimations.forEach((callback) => callback(origin, destination, direction))
    }
  },
  data: function () {
    return {
      fpOptions: {
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        anchors: ['about', 'obsession', 'work', 'contact'],
        menu: '.nav__list',
        scrollingSpeed: 1000,
        easingcss3: 'cubic-bezier(0.860, 0.000, 0.070, 1.000)',
        scrollOverflow: true,
        normalScrollElements: '.textarea__field',
        touchSensitivity: 20,
        onLeave: this.onLeave,
        recordHistory: false,
        lazyLoading: false
      },
      slideAnimations: [],
      canScroll: false
    }
  }
}
</script>

<style scoped lang="scss">
.root {
  font-size: 1rem;
}

.fullpage {
  will-change: transform;
}
</style>
